
import { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

// API functions
import { loginUser, registerUser } from "../api/api";

function Account() {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const [isLogin, setIsLogin] = useState(true);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  /* ================= EMAIL VALIDATION FUNCTION ================= */
  const isValidEmail = (email) => {
    return email.includes("@") && email.includes(".");
  };

  /* ================= LOGIN FUNCTION ================= */

  const handleLogin = async (e) => {
    e.preventDefault();

    // ✅ Email validation
    if (!isValidEmail(email)) {
      alert("Enter valid email");
      return;
    }

    try {
      const data = await loginUser({
        email: email,
        password: password,
      });

      if (data.token) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("userName", data.user?.name || email);

        login(
            data.token,
            data.user?.name || email,
            data.user?.email || email
            );

        alert("Login Successful!");
        navigate("/profile");
      } else {
        alert(data.message || "Invalid Email or Password");
      }
    } catch (error) {
      console.log(error);
      alert("Login Error");
    }
  };

  /* ================= REGISTER FUNCTION ================= */

  const handleRegister = async (e) => {
    e.preventDefault();

    // ✅ Email validation
    if (!isValidEmail(email)) {
      alert("Enter valid email");
      return;
    }

    try {
      const data = await registerUser({
        name: name,
        email: email,
        password: password,
      });

      if (!data.error) {
        alert("Registration Successful");
        setIsLogin(true);
      } else {
        alert(data.message || "Registration Failed");
      }
    } catch (error) {
      console.log(error);
      alert("Registration Error");
    }
  };

  return (
    <div className="accountPage">
      <h1>Your Account</h1>

      <div className="accountBox">
        {/* TABS */}
        <div className="accountTabs">
          <button
            onClick={() => setIsLogin(true)}
            className={isLogin ? "activeTab" : ""}
          >
            Login
          </button>

          <button
            onClick={() => setIsLogin(false)}
            className={!isLogin ? "activeTab" : ""}
          >
            Register
          </button>
        </div>

        {/* LOGIN FORM */}
        {isLogin ? (
          <form onSubmit={handleLogin}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button type="submit">Login</button>
          </form>
        ) : (
          /* REGISTER FORM */
          <form onSubmit={handleRegister}>
            <input
              type="text"
              placeholder="Full Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button type="submit">Register</button>
          </form>
        )}
      </div>
    </div>
  );
}

export default Account;